import { Button, ButtonGroup, Modal } from 'slab'

import { type Quote } from './types'

interface QuoteFeatureModalProps {
  prospectName?: string
  quote: Quote
  open: boolean
  onOpenChange: (open: boolean) => void
  onAccept: () => void
}

export const QuoteFeatureModal = ({ prospectName, quote, open, onOpenChange, onAccept }: QuoteFeatureModalProps) => (
  <Modal open={open} onOpenChange={onOpenChange}>
    <Modal.Header>
      <Modal.Title>Feature {quote.name ? `"${quote.name}"` : 'this quote'}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Modal.Description>
        Featuring this quote will bring it to the top of {prospectName ?? "this prospesct's"}'s Quotes list
        to prioritize it for review by the partner.
      </Modal.Description>
    </Modal.Body>
    <Modal.Footer>
      <ButtonGroup>
        <Button size='large' variant='secondary' onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button size='large' variant='primary' onClick={onAccept}>
          Feature quote
        </Button>
      </ButtonGroup>
    </Modal.Footer>
  </Modal>
)
